export const USER_INFO = 'USER_INFO';
export const DATA_OXXO = 'DATA_OXXO';
export const DATA_SPEI = 'DATA_SPEI';
export const DATA_CARD = 'DATA_CARD';
